import React from "react"

import { withLocked } from "./withLocked"
import { Icon } from "../Icon/Icon"
import { StyledRow } from "../Styled/Row"
import { StyledColumn } from "../Styled/Column"
import { StyledContainer } from "../Styled/Container"
import { Stats, Button, Circle, Title } from "./LockedStyles"

interface Props {
  handleRegister: any
  locales: any
}

export const Locked = withLocked(({ locales, handleRegister }: Props) => (
  <Stats>
    <StyledContainer condense={`<md`} width={`lg`}>
      <StyledRow withWrap>
        <StyledColumn width={`md:2/3`}>
          <StyledRow gutter={`sm`} withWrap={`<sm`}>
            <StyledColumn gutter={`sm`} width={`no-shrink`}>
              <Circle>
                <Icon name={`unlock`} width={30} />
              </Circle>
            </StyledColumn>
            <StyledColumn gutter={`sm`} width={`grow`}>
              <Title italic withSpacing={`md`}>
                {locales?.ctaHeading}
              </Title>
            </StyledColumn>
          </StyledRow>
        </StyledColumn>
        <StyledColumn width={`md:1/4`}>
          <Button onClick={handleRegister} title={locales?.ctaLink?.title}>
            {locales?.ctaLink?.title}
          </Button>
        </StyledColumn>
      </StyledRow>
    </StyledContainer>
  </Stats>
))
